import { Form, Input } from "decorator-form";

import EntitySelect from "common/form/fields/entitySelect/EntitySelect";
import InputType from "../../common/form/InputType";
import Program from "./entities/Program";

const entitySelect = EntitySelect.registered({entity: Program, type: 'one'}, 'string');

@Form({title: "Program status config"})
export default class ProgramStatusConfig {

	@Input({type: entitySelect, title: "Program"})
	public programId: number; // program id

	@Input({type: InputType.CHECKBOX, title: "Show resume button"})
	public resume: boolean = false;

	@Input({type: InputType.CHECKBOX, title: "Show track details"})
	public tracks: boolean = false;

	@Input({type: InputType.NUMBER, title: "Max tracks to display before jump"})
	public maxTracks: number = 4;

	@Input({type: InputType.CHECKBOX, title: "Show Pre-Test and Post-Test status"})
	public tests: boolean = true;

}



// WEBPACK FOOTER //
// ./src/panels/programStatus/ProgramStatusConfig.ts